import React from "react";
import { Container } from "react-bootstrap";
import MemberCard from "./member-card";

const TeamPage = ({members}) => {
  return (
    <section className="team-page pt-120 pb-120">
      <Container>
        <div className="team-4-col">
          {members.map(({ extraClass, MemberName, Designation, ProfilePic }, index) => (
            <MemberCard
              key={index}
              extraClass={extraClass}
              name={MemberName}
              designation={Designation}
              image={ProfilePic}
            />
          ))}
        </div>
      </Container>
    </section>
  );
};

export default TeamPage;
